import moment, { Moment } from 'moment/moment'

export interface ExternalContentPayload {
    id: number
    name: string
    description: string
    type: string
    url: string
    author: string
    tags: string[]
    published?: boolean
    sort_order: number
    created_at: string
    translations?: {}
}

export class ExternalContent {

    id: number
    name: string
    description: string
    type: string
    url: string
    author: string
    tags: string[]
    published: boolean
    sortOrder: number
    createdAt: Moment
    translations?: {} = <any>{}

    constructor(data: ExternalContentPayload) {
        this.id = data.id
        this.name = data.name
        this.description = data.description
        this.type = data.type
        this.url = data.url
        this.tags = data.tags
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.capture(data)
    }

    fill(data: ExternalContentPayload): this {
        this.id = data.id
        this.name = data.name
        this.description = data.description
        this.type = data.type
        this.url = data.url
        this.tags = data.tags
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.capture(data)
    }

    capture(data: ExternalContentPayload): this {
        if (data.translations) {
            this.translations = data.translations
        }
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
        this.translations = {}
    }

    payload(): ExternalContentPayload | any {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            type: this.type,
            url: this.url,
            tags: this.tags,
            published: this.published,
            sort_order: this.sortOrder,
            translations: this.translations,
        }
    }
}
